import { render, staticRenderFns } from "./ModalPanelGloabal.vue?vue&type=template&id=2e156554&scoped=true&"
import script from "./ModalPanelGloabal.vue?vue&type=script&lang=js&"
export * from "./ModalPanelGloabal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e156554",
  null
  
)

export default component.exports